import './index.less';
// style dependencies
import '../../empty/style';
import '../../loading/style';
